import { caseStatus } from "../constants";

export const getMessageFromCaseStatus = (caseInfo, isUpdate = false) => {
  const caseInfoStatus = caseInfo?.caseStatus;

  if (caseInfoStatus === caseStatus.completed) {
    if (isUpdate) {
      return "案件の状況は「完了」となりましたので、修正できません。";
    }
    return "案件の状況は「完了」となりましたので、作成できません。";
  }

  if (caseInfoStatus === caseStatus.lost) {
    if (isUpdate) {
      return "案件の状況は「失注」となりましたので、修正できません。";
    }
    return "案件の状況は「失注」となりましたので、作成できません。";
  }

  return null;
};
